import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTilde = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M7.664 16.462c-1.092 0-2.314.699-3.668 2.097-1.333 1.399-2.665 3.52-3.996 6.364V14.77c2.162-5.034 4.891-7.552 8.188-7.552 1.442 0 2.806.304 4.094.91s2.893 1.771 4.815 3.496c2.86 2.565 5.262 3.847 7.206 3.847 1.135 0 2.38-.723 3.734-2.169 1.375-1.445 2.697-3.52 3.963-6.224V17.16c-2.293 5.175-5.022 7.762-8.188 7.762-1.42 0-2.817-.35-4.193-1.05-1.354-.745-2.948-1.934-4.781-3.566-2.774-2.564-5.165-3.846-7.174-3.846z" /></svg>;
export default SvgTilde;